import {
  Button,
  UNSTABLE_ToastContent as ToastContent,
  UNSTABLE_Toast as Toast,
} from 'react-aria-components';
import XCircle from '@/assets/icons/XCircle.svg';
import { NotificationsQueue } from './NotificationsQueue';
import * as Styled from './Notifications.styled';

export const Notifications = () => {
  return (
    <Styled.Region queue={NotificationsQueue}>
      {({ toast }) => (
        <Toast toast={toast}>
          <ToastContent>
            <div slot="notification">{toast.content.notification}</div>
          </ToastContent>
          <Button slot="close">
            <XCircle />
          </Button>
        </Toast>
      )}
    </Styled.Region>
  );
};
